import { combineReducers } from 'redux'

import saveTransaction from './saveTransaction'
import listTransaction from './listTransaction'
import detailTransaction from './detailTransaction'

export default combineReducers({
  saveTransaction: saveTransaction,
  listTransaction: listTransaction,
  detailTransaction: detailTransaction
})
